import { CrudList } from '../shared/CrudPage';
import { bannerService } from '@kss/api';
import type { Banner, BannerCreate, BannerFilter } from '@kss/api';
import { StatusBadge, Thumbnail } from '@kss/ui';

/**
 * Banners list — wired to /api/Banner/all (live since 2026-05-02).
 *
 * Replaces the previous localStorage stub. NewBanner uses the standard
 * CrudForm pattern so the same Save button hits POST /api/Banner.
 */
export default function AllBanners() {
  return (
    <CrudList<Banner, BannerCreate, BannerFilter>
      title="All banners"
      newLabel="New banner"
      service={bannerService}
      idKey="bannerId"
      labelKey="title"
      basePath="/panel/banners"
      module="Banner"
      columns={[
        {
          accessor: 'imageUrl',
          title: '',
          width: 80,
          sortable: false,
          render: (r) => <Thumbnail src={r.imageUrl} name={r.title} seed={r.bannerId ?? r.title} className="h-12 w-20" />,
        },
        { accessor: 'title', title: 'Title', sortable: true, filterable: true },
        { accessor: 'subtitle', title: 'Subtitle', render: (r) => r.subtitle || '—' },
        { accessor: 'ctaLabel', title: 'CTA', render: (r) => r.ctaLabel || '—' },
        { accessor: 'ctaUrl', title: 'CTA URL', render: (r) => r.ctaUrl || '—' },
        {
          accessor: 'sortOrder',
          title: 'Sort',
          sortable: true,
          textAlign: 'right',
          width: 70,
          render: (r) => r.sortOrder ?? 0,
        },
        {
          accessor: 'isActive',
          title: 'Status',
          sortable: true,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
